const RATE_COMPARES = {
  yesterday: "Yesterday",
  lastWeek: "Last Week",
  lastMonth: "Last Month",
  lastYear: "Last Year"
};
export {
  RATE_COMPARES
};
